export enum ApiErrorCodes {
  NO_LECTURER_IN_LECTURE,
  CAN_NOT_DELETE_POPULATED_EXAM,
  SETTINGS_ABSTRACT_PROGRAM_CAN_NOT_BE_DELETED,
  COURSE_IS_NOT_EMPTY,
  SETTINGS_ABSTRACT_COURSE_HAS_USE_IN_ABSTRACT_PROGRAM,
  SETTINGS_SUPERVISORY_INSTITUTION_ATTACH_TO_PROGRAM,
  SETTINGS_EXAM_TYPE_HAS_USAGES,
  SETTINGS_PAYMENT_SERVICE_TYPE_HAS_USAGES,
  PAYMENT_SERVICE_HAS_ALLOCATIONS,
  NOT_VALID_RATE_REQUIREMENT,
  LECTURES_HAS_USAGE,
  DELETE_STUDENT_FROM_COURSE_HAS_USAGE,
  COMPLETE_LECTURE_INVALID_TIME_RANGE,
  COURSE_POINTS_OVER_HUNDRED,
  DELETE_LECTURER_FROM_COURSE_HAS_LECTURES,
  SETTINGS_CLASS_HAS_LECTURES,
  COURSE_CAPACITY_EXCEEDED,
  PAYMENT_SERVICE_ALREADY_PAID,
  SETTINGS_ASSIGNMENT_TYPE_LINK_TO_COURSE_ASSIGNMENT,
  SETTINGS_BRANCH_LINK_TO_BUILDINGS,
  SETTINGS_BRANCH_LINK_TO_PROGRAMS,
  SETTINGS_BRANCH_LINK_TO_COURSES,
  CALENDAR_INVALID_ITERATION_NUMBER,
  USER_NO_BRANCH_PERMISSIONS,
  PASSWORD_CHANGE_REQUIRED,
  SETTINGS_MAJOR_ATTACHED_TO_ABSTRACT_PROGRAM,
}

export const getDisplayTextForErrorCode = (errCode: ApiErrorCodes): string => {
  switch (errCode) {
    case ApiErrorCodes.NO_LECTURER_IN_LECTURE:
      return 'יש לשייך מרצה למפגש לפני סגירת המפגש';
    case ApiErrorCodes.COMPLETE_LECTURE_INVALID_TIME_RANGE:
      return 'לא ניתן לסגור הרצאה בטווח של יותר מחמש שעות מהכתנון המקורי';
    default:
      return '';
  }
};
